import React from 'react';
import {Line, LineChart, ResponsiveContainer, Tooltip, XAxis} from 'recharts';


const onlineSignups = [
    {month: 'Jan', count: 800},
    {month: 'Feb', count: 1600},
    {month: 'Mar', count: 1100},
    {month: 'Apr', count: 2600},
    {month: 'May', count: 1900},
    {month: 'Jun', count: 3200},
];


const LineChartComp = ({color, shadowColor}) => {
    return (
        <ResponsiveContainer height={80}>
            <LineChart data={onlineSignups} className={"mx-auto"}>
                <defs>
                    <filter id="shadow" height="200%">
                        <feDropShadow
                            dx="0" dy="5" stdDeviation="8"
                            floodColor={"#6610f2"}
                        />
                    </filter>
                </defs>
                <Tooltip
                    cursor={false}
                    content={({active, label, payload}) => {
                        return active ? (
                            <div className="text-white">
                                {payload.map((row, index) => (
                                    <div key={index}>{`${label}: ${row.value}`}</div>
                                ))}
                            </div>
                        ) : null;
                    }}
                    wrapperStyle={{
                        backgroundColor:  'rgba(0,0,0,.8)',
                        padding: '5px 8px',
                        borderRadius: 4,
                        overflow: 'hidden',
                        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
                    }}
                />
                <XAxis dataKey="month" hide/>
                <Line dataKey="count"
                      filter="url(#shadow)"
                      type="monotone"
                      dot={null}
                      strokeWidth={3}
                      stackId="2"
                      stroke={"#FFFFFF"}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};
/* Todo color, shadowColor prop define */
export default LineChartComp;
